import React from 'react';
import { Body, Box, Heading } from '@hover/blueprint';
import { ArrowButton } from '@hover/shared-components';
import { Link } from 'gatsby';
import { handleClickAndRedirect } from '../../../../utils/CtaHandleClick';

interface IStartInstantlyProps {
  heading: string;
  body: string;
  cta?: {
    label: string;
    href: string | (() => void);
  };
  getADemo?: {
    label: string;
    href: string | (() => void);
  };
  page: string;
  fullWidth?: boolean;
  headingSize?: { base: string; desktop: string };
  bodySize?: { base: string; desktop: string };
  innerMaxW?: { base: string; desktop: string };
  outerMaxw?: string;
}

const StartInstantly: React.FC<IStartInstantlyProps> = ({
  heading,
  body,
  cta,
  getADemo,
  page,
  fullWidth,
  headingSize,
  bodySize,
  innerMaxW,
  outerMaxw,
}) => (
  <Box
    px={{ base: 6, tablet: 10 }}
    pt={{ base: 12, tablet: 10 }}
    pb={{ base: 8, tablet: 10 }}
    maxW={
      fullWidth
        ? '100%'
        : {
            base: 'calc(100% - 48px)',
            tablet: 'calc(100% - 32px)',
            desktop: outerMaxw || '7xl',
          }
    }
    w="100%"
    bgColor="primary.100"
    borderRadius={{ base: 0, tablet: 8 }}
    justifyContent="center"
    mb={fullWidth ? 0 : { base: 5, tablet: 4, desktop: 16 }}
  >
    <Box
      maxW={innerMaxW || { base: '100%', desktop: '5xl' }}
      w="100%"
      justifyContent="space-between"
      alignItems={{ base: 'flex-start', tablet: 'center' }}
      flexDirection={{ base: 'column', desktop: 'row' }}
    >
      <Box d="block">
        <Heading
          as="h2"
          color="primary.900"
          fontSize={headingSize || '30px'}
          maxW={{ base: '520px' }}
          sx={{ mb: { base: '16px', tablet: '8px' } }}
          lineHeight={{ base: 'normal', tablet: '48px' }}
        >
          {heading}
        </Heading>
        <Body color="primary.900" maxW="2xl">
          <Box
            fontSize={bodySize || { base: '16px', tablet: '20px' }}
            lineHeight={{ base: 7, desktop: 9 }}
          >
            {body}
          </Box>
        </Body>
      </Box>
      <Box
        flexDirection={{ base: 'column', desktop: 'column' }}
        gap={{ base: '0rem', tablet: '1rem' }}
        width={{ base: '100%', tablet: 'auto' }}
      >
        {cta && typeof cta.href === 'string' ? (
          <ArrowButton
            colorScheme="brandNavy"
            variant="solid"
            to={cta.href}
            as={Link}
            w={{ base: '178px', tablet: 'auto' }}
            mt={{ base: 8, desktop: 0 }}
            letterSpacing="0.42px"
          >
            {cta.label}
          </ArrowButton>
        ) : (
          cta &&
          typeof cta.href !== 'string' && (
            <ArrowButton
              colorScheme="brandNavy"
              variant="solid"
              onClick={cta.href}
              w={{ base: '178px', tablet: 'auto' }}
              mt={{ base: 8, desktop: 0 }}
              letterSpacing="0.42px"
            >
              {cta.label}
            </ArrowButton>
          )
        )}
        {getADemo && typeof getADemo.href === 'string' ? (
          <ArrowButton
            colorScheme="brandNavy"
            variant="minimal"
            onClick={() =>
              handleClickAndRedirect(
                getADemo.label || 'Get a demo',
                getADemo.href,
                page,
              )
            }
            w={{ base: '178px', tablet: 'auto' }}
            mt={{ base: 8, desktop: 0 }}
            sx={{ div: { pl: 100, pr: 50 } }}
            letterSpacing="0.42px"
          >
            {getADemo.label}
          </ArrowButton>
        ) : (
          getADemo &&
          typeof getADemo.href !== 'string' && (
            <ArrowButton
              colorScheme="brandNavy"
              variant="minimal"
              onClick={getADemo.href}
              w={{ base: '178px', tablet: 'auto' }}
              mt={{ base: 4, desktop: 0 }}
              sx={{ div: { pl: 100, pr: 50 } }}
              letterSpacing="0.42px"
            >
              {getADemo.label}
            </ArrowButton>
          )
        )}
      </Box>
    </Box>
  </Box>
);

export default StartInstantly;
